
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Package, TrendingUp, Calendar, Target } from "lucide-react";

interface OffersData {
  today: { count: number; revenue: number };
  yesterday: { count: number; revenue: number };
  month: { count: number; revenue: number };
}

interface OffersStatsCardsProps {
  data: OffersData;
  isLoading?: boolean;
}

export const OffersStatsCards = ({ data, isLoading }: OffersStatsCardsProps) => {
  const statsCards = [
    {
      title: "عروض اليوم",
      value: data.today.count,
      revenue: data.today.revenue,
      icon: Package,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      textColor: "text-blue-600"
    },
    {
      title: "عروض الأمس",
      value: data.yesterday.count,
      revenue: data.yesterday.revenue,
      icon: Calendar,
      color: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-50",
      textColor: "text-purple-600"
    },
    {
      title: "عروض الشهر",
      value: data.month.count,
      revenue: data.month.revenue,
      icon: Target,
      color: "from-emerald-500 to-emerald-600",
      bgColor: "bg-emerald-50",
      textColor: "text-emerald-600"
    }
  ];

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="animate-pulse">
            <CardContent className="p-6">
              <div className="h-20 bg-gray-200 rounded"></div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {statsCards.map((card, index) => {
        const Icon = card.icon;
        return (
          <Card key={index} className={`${card.bgColor} border-0 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105`}>
            <CardHeader className="pb-3">
              <div className="flex items-center justify-between">
                <CardTitle className={`text-lg font-bold ${card.textColor}`}>
                  {card.title}
                </CardTitle>
                <div className={`p-3 rounded-xl bg-gradient-to-r ${card.color} shadow-lg`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </div>
            </CardHeader>
            <CardContent className="pt-0">
              <div className="space-y-2">
                <div className={`text-3xl font-bold ${card.textColor}`}>
                  {card.value.toLocaleString()}
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <TrendingUp className="w-4 h-4" />
                  <span>الإيرادات: {card.revenue.toLocaleString()} ر.س</span>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
